import { styled } from 'styled-components'

import FormField from '../../FormField'

export const CounterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 10px;

  .subtitle {
    font-size: 14px;
    font-weight: 400;
  }
`

export const ListContainer = styled.ul`
  border-bottom: 1px solid #bcddeb;
  border-top: 1px solid #bcddeb;
  padding: 15px;
`

export const ListItem = styled.li`
  display: flex;
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
`

export const CheckboxField = styled(FormField)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 35px);
  margin-bottom: 0;

  input {
    width: auto;
  }

  label {
    font-size: 14px;
    color: #0a0a18;
  }
`

export const Photo = styled.div<{ $img: string }>`
  width: 30px;
  height: 30px;
  background-image: ${(props) => `url(${props.$img})`};
  border-radius: 50%;
  background-position: center;
  background-size: cover;
`
